import apiClient from "../../../utilities/apiClient";

// ---------------------------------------
// Create User
// ---------------------------------------
export const createUserApi = (payload) => {
    return apiClient.post(
        `${apiClient.Urls.chatusers}create`,
        payload,
        true
    );
};
export const manageUsersGroupsApi = (payload) => {
    return apiClient.post(
        `${apiClient.Urls.manageusers}/${payload?.params?.groupId}`,
        payload.body,
        true
    );
};
// ---------------------------------------
// Edit User
// ---------------------------------------
export const editUserApi = (payload) => {
    return apiClient.put(
        `${apiClient.Urls.chatusers}edit/${payload?.id}`,
        payload,
        true
    );
};

// ---------------------------------------
// Get User by ID
// ---------------------------------------
export const getUserApi = (id) => {
    return apiClient.get(
        `${apiClient.Urls.chatusers}${id}`,
        {},
        true
    );
};

// ---------------------------------------
// Get Users (list with pagination & search)
// ---------------------------------------
export const getUsersApi = (params = {}) => {
    const query = new URLSearchParams(params).toString();

    return apiClient.get(
        `${apiClient.Urls.chatusers}?${query}`,
        {},
        true
    );
};


// Get Users of groups manage
export const getGroupsUsersApi = (params = {}) => {
    const query = new URLSearchParams(params).toString();

    return apiClient.get(
        `${apiClient.Urls.groupusers}/${params?.groupId}?${query}`,
        {},
        true
    );
};
// ---------------------------------------
// Get Messages
// ---------------------------------------
export const getMessages = (params = {}) => {
    const query = new URLSearchParams(params).toString();

    return apiClient.get(
        `${apiClient.Urls.chats}?${query}`,
        {},
        true
    );
};

// ---------------------------------------
// Get Groups
// ---------------------------------------
export const getGroupsApi = (params = {}) => {
    const query = new URLSearchParams(params).toString();

    return apiClient.get(
        `${apiClient.Urls.chatgroups}?${query}`,
        {},
        true
    );
};

// ---------------------------------------
// Create Group
// ---------------------------------------
export const createGroup = (payload) => {
    return apiClient.post(
        `${apiClient.Urls.creategroup}`,
        payload,
        true
    );
};

// ---------------------------------------
// Update Group
// ---------------------------------------
export const updateGroup = (payload) => {
    return apiClient.put(
        `${apiClient.Urls.updategroup}${payload?.id}`,
        payload,
        true
    );
};
